// src/config/eventApi.js
// Thin wrapper around the public event-registration API.
// Keeps every endpoint in one place and reuses the shared BASE_URL.
import axios from "axios";
import BASE_URL from "../config";

const API = `${BASE_URL}/api/event-registration`;

// Build an axios instance that forwards the current UI language so the
// backend can return the right _ar / _en multilingual fields.
const client = (lang = "fr") =>
  axios.create({
    baseURL: API,
    headers: { "Accept-Language": lang, Accept: "application/json" },
  });

const eventApi = {
  // GET the public event registration page (by slug or id)
  getEvent: (slug, lang) => client(lang).get(`/${encodeURIComponent(slug)}`),

  // Verification lookups
  lookupCompany: (rc, lang, idEvent) =>
    client(lang).post(`/company/lookup`, idEvent ? { rc, id_event: idEvent } : { rc }),
  lookupParticipant: (payload, lang) =>
    client(lang).post(`/participant/lookup`, payload),

  // OTP
  sendOtp: (payload, lang) => client(lang).post(`/otp/send`, payload),
  verifyOtp: (payload, lang) => client(lang).post(`/otp/verify`, payload),

  // Submit
  submit: (payload, lang) => client(lang).post(`/submit`, payload),

  // Update an existing registration (add/remove participants, or cancel)
  updateRegistration: (payload, lang) =>
    client(lang).post(`/registration/update`, payload),

  // Reference data (sectors, wilayas, event categories)
  refSecteurs: (lang) => client(lang).get(`/ref/secteurs`),
  refWilayas: (lang) => client(lang).get(`/ref/wilayas`),
  refEventCategories: (lang) => client(lang).get(`/ref/event-categories`),
  refAll: (lang) => client(lang).get(`/ref/all`),

  // Payment
  paymentInit: (reference, lang) =>
    client(lang).post(`/payment/init`, { reference }),

  // Door verification (organizers)
  verify: (reference, badge, lang) =>
    client(lang).get(`/verify/${reference}`, { params: badge ? { badge } : {} }),
};

// Helpers shared by the registration pages (same style as ArticleDetail.js)
export const pickLang = (obj, base, lang) => {
  if (!obj) return "";
  if (lang === "ar" && obj[`${base}_ar`]) return obj[`${base}_ar`];
  if (lang === "en" && obj[`${base}_en`]) return obj[`${base}_en`];
  return obj[base] || "";
};

// Build the public badge download URL for a participant
export const badgeUrl = (reference, participantId) =>
  `${API}/${reference}/badge/${participantId}`;

export { BASE_URL, API };
export default eventApi;